import React from "react"
import { ToggleOption } from "../ToggleOption"

interface ToggleProps {
  options: object[],
  selected?: string | string[] | number,
  onSelect: Function,
  listClasses?: string,
  activeClassName?: string,
  inactiveClassName?: string,
  buttonClassName?: string
}

class ToggleInner extends React.Component<ToggleProps> {
  static defaultProps: ToggleProps = {
    options: [],
    onSelect: () => {},
    listClasses: "border-solid border-gray-pure border rounded overflow-hidden",
  }

  constructor(props: ToggleProps) {
    super(props)

    this.renderOption = this.renderOption.bind(this)
    this.selectedOption = this.selectedOption.bind(this)
  }

  selectedOption(option) {
    const { selected } = this.props
    return JSON.stringify(option.value) === JSON.stringify(selected)
  }

  renderOption(option) {
    const {
      onSelect, activeClassName, inactiveClassName, buttonClassName,
    } = this.props
    return (
      <ToggleOption
        onSelect={onSelect}
        selected={this.selectedOption(option)}
        key={option.value}
        activeClassName={activeClassName}
        inactiveClassName={inactiveClassName}
        buttonClassName={buttonClassName}
        {...option}
      />
    )
  }

  render() {
    const { options, listClasses } = this.props
    return (
      <ul className={listClasses}>
        {options.map(this.renderOption)}
      </ul>
    )
  }
}

export function Toggle(props: ToggleProps) {
  return <ToggleInner {...props} />
}
